// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Ebxq","inputWrap":"Table_inputWrap__2PLOE","col":"Table_col__1RTXt","bmiTooltip":"Table_bmiTooltip__1nK4l"};